import { Component, Input, OnInit } from '@angular/core';
import { StepFormService } from 'src/app/services/StepForm/step-form.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  @Input() step: number = 1;

  steps = [
    { number: 1, label: 'Dados do Agendamento', icon: 'edit' },
    { number: 2, label: 'Vinculação de Acompanhantes', icon: 'check_circle' }
  ];

  isActive(stepNumber: number): boolean {
    return stepNumber === this.step;
  }

  isCompleted(stepNumber: number): boolean {
    return stepNumber < this.step;
  }
}
